// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/TestTiemposHeadline-Medium.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "TiemposHeadline";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
  font-weight: normal;
  font-style: normal;
}

body {
  margin: 0;
}

#intro {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  flex-direction: column;
}

/* Parent container to hold two columns side by side */
.intro-container {
  position: relative;
  display: flex; /* Enables Flexbox */
  align-items: center; /* Vertically center items */
  gap: 20px;
  flex-direction: column;
}

/* Image styling */
.graphic-overlay img {
  display: flex;
  justify-content: center;
  width: 100%; /* Limit image width */
  border-radius: 50%; /* Optional: Rounded corners */
}

.circle-photo {
  flex: 1 1;
  height: auto;
  transition: transform 0.1s ease-out; /* Smooth movement */
}

.dotted-line-right {
  position: absolute;
  top: 40%;
  right: -360px;
}

.dotted-line-left {
  position: absolute;
  top: 60%;
  left: -320px;
}

.text-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.text-block-left {
  width: 400px;
  position: absolute;
  top: 42%;
  left: -320px;
  text-align: left;
}

.text-block-right {
  position: absolute;
  top: 23%;
  right: -350px;
  text-align: right;
}

.line-text-left {
  font-size: 1.2rem;
}

.line-text-right {
  font-size: 2.5rem;
  font-family: "TiemposHeadline";
  letter-spacing: 1.2px;
}

.icons-container {
  display: flex;
  flex-direction: row;
  padding-top: 0.5rem;
  gap: 1.5rem;
}

.icon-button {
  cursor: pointer;
  transition: transform 0.2s ease, color 0.2s ease;
}

.icon-button:hover {
  transform: scale(1.2);
}

.icon-button:active {
  transform: scale(1);
}

.intro-text .letschat {
  display: inline-block;
  padding: 0.5rem 2rem;
  margin-top: 1rem;
  background-color: #b79ced;
  border-radius: 10px;
  border-width: 0px;
  color: #171717;
  box-shadow: -2px 2px rgba(230, 228, 231, 0.8);
  font-family: "TiemposHeadline", serif;
  letter-spacing: 0.5px;
  font-size: 1.5rem;
}

/* for smaller screens: FIX!*/
@media (max-width: 768px) {
  .intro-container {
    flex-direction: column; /* Stack elements vertically */
    gap: 20px;
    padding-top: 20rem;
  }

  .text-block-left {
    position: static;
    text-align: right;
    width: 60%;
    padding-right: 5rem;
    padding-bottom: 20rem;
  }
  .text-block-right {
    position: static; /* Reset position to static for stacking */
    text-align: center;
    width: 100%; /* Take full width */
    padding-top: 20rem;
  }

  .dotted-line-left {
    transform: rotate(90deg) translate(-5rem, -5rem);
    position: static;
    display: block;
    clip-path: inset(0 0 40% 40%);
  }

  .dotted-line-right {
    transform: rotate(90deg) translate(20rem, 5rem);
    position: static;
    display: block;
    padding-left: 20rem;
  }

  .circle-photo {
    max-width: 30rem;
  }

  .icons-container {
    position: static;
    justify-content: right;
    padding-top: 1rem;
    gap: 1rem;
    padding-right: 8rem;
  }

  .line-text-left {
    font-size: 1rem;
    padding-right: 7rem;
  }

  .line-text-right {
    font-size: 2rem;
    padding-left: 10rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Intro.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,+DAAuE;EACvE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,aAAa,EAAE,oBAAoB;EACnC,mBAAmB,EAAE,4BAA4B;EACjD,SAAS;EACT,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW,EAAE,sBAAsB;EACnC,kBAAkB,EAAE,8BAA8B;AACpD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mCAAmC,EAAE,oBAAoB;AAC3D;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,6CAA6C;EAC7C,qCAAqC;EACrC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE;IACE,sBAAsB,EAAE,8BAA8B;IACtD,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,gBAAgB,EAAE,0CAA0C;IAC5D,kBAAkB;IAClB,WAAW,EAAE,oBAAoB;IACjC,kBAAkB;EACpB;;EAEA;IACE,gDAAgD;IAChD,gBAAgB;IAChB,cAAc;IACd,6BAA6B;EAC/B;;EAEA;IACE,+CAA+C;IAC/C,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF","sourcesContent":["@font-face {\n  font-family: \"TiemposHeadline\";\n  src: url(\"../assets/TestTiemposHeadline-Medium.otf\") format(\"opentype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\nbody {\n  margin: 0;\n}\n\n#intro {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 80vh;\n  flex-direction: column;\n}\n\n/* Parent container to hold two columns side by side */\n.intro-container {\n  position: relative;\n  display: flex; /* Enables Flexbox */\n  align-items: center; /* Vertically center items */\n  gap: 20px;\n  flex-direction: column;\n}\n\n/* Image styling */\n.graphic-overlay img {\n  display: flex;\n  justify-content: center;\n  width: 100%; /* Limit image width */\n  border-radius: 50%; /* Optional: Rounded corners */\n}\n\n.circle-photo {\n  flex: 1;\n  height: auto;\n  transition: transform 0.1s ease-out; /* Smooth movement */\n}\n\n.dotted-line-right {\n  position: absolute;\n  top: 40%;\n  right: -360px;\n}\n\n.dotted-line-left {\n  position: absolute;\n  top: 60%;\n  left: -320px;\n}\n\n.text-container {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.text-block-left {\n  width: 400px;\n  position: absolute;\n  top: 42%;\n  left: -320px;\n  text-align: left;\n}\n\n.text-block-right {\n  position: absolute;\n  top: 23%;\n  right: -350px;\n  text-align: right;\n}\n\n.line-text-left {\n  font-size: 1.2rem;\n}\n\n.line-text-right {\n  font-size: 2.5rem;\n  font-family: \"TiemposHeadline\";\n  letter-spacing: 1.2px;\n}\n\n.icons-container {\n  display: flex;\n  flex-direction: row;\n  padding-top: 0.5rem;\n  gap: 1.5rem;\n}\n\n.icon-button {\n  cursor: pointer;\n  transition: transform 0.2s ease, color 0.2s ease;\n}\n\n.icon-button:hover {\n  transform: scale(1.2);\n}\n\n.icon-button:active {\n  transform: scale(1);\n}\n\n.intro-text .letschat {\n  display: inline-block;\n  padding: 0.5rem 2rem;\n  margin-top: 1rem;\n  background-color: #b79ced;\n  border-radius: 10px;\n  border-width: 0px;\n  color: #171717;\n  box-shadow: -2px 2px rgba(230, 228, 231, 0.8);\n  font-family: \"TiemposHeadline\", serif;\n  letter-spacing: 0.5px;\n  font-size: 1.5rem;\n}\n\n/* for smaller screens: FIX!*/\n@media (max-width: 768px) {\n  .intro-container {\n    flex-direction: column; /* Stack elements vertically */\n    gap: 20px;\n    padding-top: 20rem;\n  }\n\n  .text-block-left {\n    position: static;\n    text-align: right;\n    width: 60%;\n    padding-right: 5rem;\n    padding-bottom: 20rem;\n  }\n  .text-block-right {\n    position: static; /* Reset position to static for stacking */\n    text-align: center;\n    width: 100%; /* Take full width */\n    padding-top: 20rem;\n  }\n\n  .dotted-line-left {\n    transform: rotate(90deg) translate(-5rem, -5rem);\n    position: static;\n    display: block;\n    clip-path: inset(0 0 40% 40%);\n  }\n\n  .dotted-line-right {\n    transform: rotate(90deg) translate(20rem, 5rem);\n    position: static;\n    display: block;\n    padding-left: 20rem;\n  }\n\n  .circle-photo {\n    max-width: 30rem;\n  }\n\n  .icons-container {\n    position: static;\n    justify-content: right;\n    padding-top: 1rem;\n    gap: 1rem;\n    padding-right: 8rem;\n  }\n\n  .line-text-left {\n    font-size: 1rem;\n    padding-right: 7rem;\n  }\n\n  .line-text-right {\n    font-size: 2rem;\n    padding-left: 10rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
